import { ContentType } from 'src/types/publishedAssets';
import { ContentContainer } from 'components/Content/Atoms/ContentContainer';
import { useGetContentTranslations } from 'src/utils/useGetContentTranslations';
import { BlockHeading } from 'components/Content/Atoms/BlockHeading';
import styles from './LinkContent.module.scss';

interface LinkContentProps {
  content: ContentType;
}

export function LinkContent(props: LinkContentProps) {
  const { content } = props;
  const { translate } = useGetContentTranslations();
  const title = translate(content.translations, 'label');
  const description = translate(content.translations, 'description');
  const linkDisplayType = content?.display_type === 'link_grid' ? styles.linkGrid : styles.linkList;
  const showButtons = content?.metadata?.style === 'button';
  return (
    <ContentContainer content={content}>
      <div className={styles.linkContainer}>
        <BlockHeading title={title} secondaryText={description} id={content.id} />
        <div className={linkDisplayType}>
          {content.components.map((component) => {
            const linkTitle = translate(component.translations!, 'label');
            const linkUrl = translate(component.translations!, 'url');
            if (!linkUrl) return null;
            if (showButtons) {
              return (
                <a
                  href={linkUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={component.id}
                  className={styles.linkButton}
                >
                  {linkTitle}
                </a>
              );
            }
            return (
              <a
                href={linkUrl}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.linkItem}
                key={component.id}
              >
                {linkTitle}
              </a>
            );
          })}
        </div>
      </div>
    </ContentContainer>
  );
}

export default LinkContent;
